import { FontSizes } from '../FluentType';
import { FontWeights } from '@uifabric/styling';
export var DetailsColumnStyles = function () {
    return {
        cellName: {
            fontWeight: FontWeights.semibold,
            fontSize: FontSizes.size14,
        },
        filterChevron: {
            fontSize: FontSizes.size12,
            paddingLeft: 6,
        },
    };
};
//# sourceMappingURL=DetailsColumn.styles.js.map